import { useFormik } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createJob } from '../../actions/jobsAxctions'
import CreateJobView from '../../containers/Jobs/CreateJob/CreateJob'

const CreateJob = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const formik = useFormik({
    initialValues:{
      name:"",
      mimSalary:"",
      maxSalary:"",
      knowledgeArea:"",
      description:"",
      limitDate: "",
      country:"",
      state:"",
      city:"",
      quantityVacancies:"",
      company:"",
      email:"",
      contact:""

    },
    onSubmit:(values)=>{
      const formData = new FormData()
      formData.append("name",values.name)
      formData.append("mimSalary",values.mimSalary)
      formData.append("maxSalary",values.maxSalary)
      formData.append("knowledgeArea",values.knowledgeArea)
      formData.append("description",values.description)
      formData.append("limitDate",values.limitDate)
      formData.append("country",values.country)
      formData.append("state",values.state)
      formData.append("city",values.city)
      formData.append("quantityVacancies",values.quantityVacancies)
      formData.append("company",values.company)
      formData.append("email",values.email)
      formData.append("contact",values.contact)
      formData.append("picture",values.picture)
      formData.append("offerpdf",values.offerpdf)
      dispatch(createJob(formData,history))
    }
    

  })
  return (
    <CreateJobView formik={formik}/>
  )
}

export default CreateJob